// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-left-hand-setting{min-width:0 !important;max-width:370px}`, "",{"version":3,"sources":["webpack://./src/components/saml/style.scss"],"names":[],"mappings":"AAAA,2BAEI,sBAAA,CACA,eAAA","sourcesContent":[".content-left-hand-setting {\n\n    min-width: 0 !important;\n    max-width: 370px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentLeftHandSetting": `content-left-hand-setting`
};
export default ___CSS_LOADER_EXPORT___;
